import { EmlMessage, HtmlGenerator } from '@utils';
import { store } from '../store';
import { AnswerEntityInterface } from '@types';
import { ImageShape } from '@enums';

export const generateAnswerEml = (letterName: string, answer: AnswerEntityInterface): void => {
  const answerEnvironment = store?.getState().answerEnvironment;
  const answerQuestionnaireData = JSON.parse(answer.questionnaire.data);

  const html = new HtmlGenerator(answer.questionnaire.renderer.data, answerEnvironment).getHtml(
    true
  );

  const downloadLink = document.createElement('a');
  /** Interpolating if the value is dynamic
   * providing context to be executed
   */
  const subject = new HtmlGenerator(answerQuestionnaireData?.subject, answerEnvironment).getHtml();

  const message = new EmlMessage(subject, {}, html, [], { 'X-Unsent': '1' });

  message.addAttachment(
    answerEnvironment.attachments
      .filter((item) => message.html.includes(item.name))
      .map((item) => {
        const regexp = new RegExp(`<img[^>]+src="cid:${item.name}"[^>]*>`);
        const tag = message.html.match(regexp)?.[0];
        const shape = tag?.match(/(?<=data-shape=")\w+/)?.[0];

        switch (shape) {
          case ImageShape.CIRCLE: {
            return { ...item.data, data: item.data.data[ImageShape.CIRCLE] };
          }
          case ImageShape.SQUARE: {
            return { ...item.data, data: item.data.data[ImageShape.SQUARE] };
          }
          default: {
            return item.data;
          }
        }
      })
  );

  downloadLink.download = `${letterName}.eml`;
  downloadLink.href = message.createMessage();
  downloadLink.click();
};
